import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import BatchQueryModal from '@/tiktok-platform/modules/products/components/BatchQueryModal';
import {
  joinBatchTokens,
  BATCH_QUERY_LIMIT,
} from '@/tiktok-platform/modules/products/components/batchQueryUtils';

/**
 * 模板库款号批量查询：标签 + 输入（逗号批量）+「+」弹窗，交互对齐商品列表货号筛选。
 */
export default function TiktokStyleNoBatchFilter({
  value = '',
  disabled = false,
  onChange,
  onEnter,
  className = '',
}) {
  const { t } = useTranslation('workbench');
  const [batchOpen, setBatchOpen] = useState(false);

  return (
    <>
      <div className={['tko-field tko-field--inline tko-field--batch tko-field--style-no', className].filter(Boolean).join(' ')}>
        <span className="tko-field__label">{t('productTemplate.colStyleNo')}</span>
        <input
          className="tko-input"
          value={value}
          disabled={disabled}
          placeholder={t('productTemplate.styleNoPh')}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onEnter?.();
          }}
        />
        <button
          type="button"
          className="tko-batch-add-btn"
          disabled={disabled}
          aria-label={t('productTemplate.batchStyleAria')}
          title={t('returnList.batchQuery')}
          onClick={() => setBatchOpen(true)}
        >
          <Plus size={16} strokeWidth={2.25} aria-hidden="true" />
        </button>
      </div>
      <BatchQueryModal
        open={batchOpen}
        title={t('productTemplate.batchStyleTitle')}
        initialValue={value}
        placeholder={t('productTemplate.batchStylePh', { count: BATCH_QUERY_LIMIT })}
        onClose={() => setBatchOpen(false)}
        onConfirm={(tokens) => {
          onChange?.(joinBatchTokens(tokens.slice(0, BATCH_QUERY_LIMIT)));
        }}
      />
    </>
  );
}
